<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Action_Name">Action Name</label>
              <input
                myFocus
                type="text"
                name="Action_Name"
                [(ngModel)]="dsCollection.criteria.Action_Name"
                ngControl="Action_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>

          <div class="col-12 col-lg-8">
            <unity-button-old
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
            >
              Search
            </unity-button-old>
            <unity-button-old
              class="pull-right margin-l-5"
              type="button"
              (click)="dsCollection.criteria.Action_Name = ''; model.dirty = true"
              classes="secondary"
              style="margin-top: 16px"
            >
              Reset
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #actionFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header">
            <tr *ngIf="dsCollection.objectNodes && dsCollection.objectNodes.length > 0">
              <th>Action Name</th>
              <th>Action Desc</th>
            </tr>
            <tr
              *ngFor="
                let action of dsCollection.objectNodes | epFilter : actionFilter.filter : actionFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(action)"
            >
              <td>
                {{ action.Action_Name }}
              </td>
              <td>
                {{ action.Action_Desc }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Actions</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
